import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { Link } from "react-router-dom";
import { FiEdit3, FiTrash2, FiEye } from "react-icons/fi";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const CurrencyTable = () => {
  const [rows, setRows] = useState([]);
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  const fetchData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/currencies`,
    );
    setRows(res.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleStatus = async (id, status) => {
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/currencies/${id}/status`,
      {
        status: status === 1 ? 0 : 1,
      },
    );
    fetchData();
  };

  // ✅ Varsayılan Para Birimi Değiştirme
  const setDefault = async (id) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/currencies/${id}/set-default`,
      );
      toast.success("Varsayılan para birimi güncellendi");
      fetchData();
    } catch {
      toast.error("Hata oluştu");
    }
  };

  const handleDelete = (id) => {
    confirmAlert({
  title: getText("DESTROY_CONFIRM_TITLE"),
      message: getText("DESTROY_CONFIRM_MSG"),
      buttons: [
        {
         label: getText("YES_DELETE"),
          onClick: async () => {
            await axios.delete(
              `${process.env.REACT_APP_API_BASE_URL}/api/currencies/${id}`,
            );
            toast.success(getText("SUCCESS_DELETED"));
            fetchData();
          },
        },
           { label: getText("CANCEL")},
      ],
    });
  };

  const Switch = ({ checked, onChange }) => (
    <div className="form-check form-switch text-center">
      <input
        className="form-check-input"
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{ cursor: "pointer", width: 45, height: 22 }}
      />
    </div>
  );

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: getText("TABLE_ID_LABEL"), size: 60 },
      { accessorKey: "code", header: getText("TABLE_CODE_LABEL")},
      { accessorKey: "symbol", header: getText("TABLE_SYMBOL_LABEL")},
      { accessorKey: "name", header: getText("TABLE_TITLE_LABEL") },

      {
        accessorKey: "is_default",
        header: getText("TABLE_DEFAULT_LABEL"),
        cell: ({ row }) => (
          <Switch
            checked={row.original.is_default === 1}
            onChange={() => setDefault(row.original.id)}
          />
        ),
      },

      {
        accessorKey: "status",
        header: getText("TABLE_STATUS_LABEL"),
        cell: ({ row }) => (
          <Switch
            checked={row.original.status === 1}
            onChange={() => toggleStatus(row.original.id, row.original.status)}
          />
        ),
      },

      {
        accessorKey: "actions",
        header: getText("TABLE_ACTIONS_LABEL"),
        cell: ({ row }) => (
          <div className="d-flex gap-2">
            <Link
              to={`/currency/view/${row.original.id}`}
              className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
              title={getText("VIEW")}
            >
              <FiEye />
            </Link>
            <Link
              to={`/currency/edit/${row.original.id}`}
              className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
              title={getText("EDIT")}
            >
              <FiEdit3 />
            </Link>
            <button
              className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
              title={getText("DELETE")}
              onClick={() => handleDelete(row.original.id)}
            >
              <FiTrash2 />
            </button>
          </div>
        ),
      },
    ],
     [translations],
  );

  return <Table data={rows} columns={columns} />;
};

export default CurrencyTable;
